import TabTemplate from "components/shared/profile/tab";
import { catalogEntityOptionFlags, catalogEntityOptionFlagsEnum, entityTypes, entityTypesEnum } from "helpers/enums";
import { enumLabel } from "helpers/system";
import React from "react";
import { getList, getProperties } from "sources/catalogs";
import { getCombinedProperties } from "sources/extendedProperties";
import EntityOption from "./entityOption";

const extendedPropertiesMapper = {
    bid: entityTypesEnum.TruckingBid,
    bidPoint: entityTypesEnum.BidPoint,
    cargo: entityTypesEnum.Cargo,
};

export default class OrgEntityOptionsTab extends TabTemplate {
    initialState = {
        properties: {},
        values: {},
    };

    componentDidMount() {
        this.getData();
    }

    getData = () => {
        this.setState({ isLoading: true });
        Promise.all([getProperties(), getList(), getCombinedProperties({ excludeHidden: false })]).then(
            ([props, data, extendedProperties]) => {
                const properties = props.reduce((memo, item) => {
                    memo[item.entityType] = item;
                    return memo;
                }, {});
                Object.entries(extendedProperties).map(([key, options]) => {
                    properties[extendedPropertiesMapper[key]].entityOptions =
                        properties[extendedPropertiesMapper[key]].entityOptions.concat(options);
                    return null;
                });
                const values = {};
                data.forEach((option) => {
                    if (!values[option.entityType]) {
                        values[option.entityType] = {};
                    }
                    values[option.entityType][option.entityOptionId] = option;
                });
                this.setState({ values, properties, isLoading: false });
            },
        );
    };

    renderProperties = (kind, props) => {
        const title = enumLabel(entityTypes, kind);
        return (
            <div key={kind} className="card card-body mb-3">
                <table className="table table-striped table-sm">
                    <thead>
                        <tr>
                            <th colSpan="3">
                                <h6 className="mb-0">{title}</h6>
                            </th>
                        </tr>
                        <tr>
                            <th>Название</th>
                            <th className="w-25">
                                {enumLabel(catalogEntityOptionFlags, catalogEntityOptionFlagsEnum.Invisible)}
                            </th>
                            <th className="w-25">
                                {enumLabel(catalogEntityOptionFlags, catalogEntityOptionFlagsEnum.Required)}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {props.map((p) => {
                            const { intFlags, intRelationFlags } =
                                this.state.values[kind] && this.state.values[kind][p.id]
                                    ? this.state.values[kind][p.id]
                                    : { intFlags: 0, intRelationFlags: 0 };
                            return (
                                <EntityOption
                                    key={p.id}
                                    kind={kind}
                                    data={p}
                                    intFlags={intFlags}
                                    intRelationFlags={intRelationFlags}
                                    modal={this.props.modal}
                                    refreshList={this.getData}
                                    roles={this.props.roles}
                                />
                            );
                        })}
                    </tbody>
                </table>
            </div>
        );
    };

    renderBody = () => {
        return Object.entries(this.state.properties).map(({ 0: kind, 1: prop }) =>
            this.renderProperties(kind, prop.entityOptions),
        );
    };
}
